import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import auditCodeService from "../../../../services/auditCodeService";
import { auditCodeQueryKey } from "../queries/auditCodeQueries";

export const useGenerateAuditCodeMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ storeId, storeLocationId }: { storeId: string; storeLocationId: string }) =>
            auditCodeService.generateAuditCode(storeId, storeLocationId),
        onSuccess: (_response, { storeId }) => {
            toast.success("LottoReco Audit Code generated.");
            queryClient.invalidateQueries({ queryKey: auditCodeQueryKey(storeId) });
        },
        onError: (error: any) => {
            toast.error(error?.response?.data?.detail || "Failed to generate LottoReco Audit Code.");
        },
    });
};

export const useRevokeAuditCodeMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ storeId, storeLocationId }: { storeId: string; storeLocationId: string }) =>
            auditCodeService.revokeAuditCode(storeId, storeLocationId),
        onSuccess: (_response, { storeId }) => {
            toast.success("LottoReco Audit Code revoked.");
            queryClient.invalidateQueries({ queryKey: auditCodeQueryKey(storeId) });
        },
        onError: (error: any) => {
            toast.error(error?.response?.data?.detail || "Failed to revoke LottoReco Audit Code.");
        },
    });
};
